<a (click)="reset()">Reset Game and Exit</a>
